import { jsx as _jsx } from "react/jsx-runtime";
import { createMoovyTheme } from 'moovy-ui-core';
import { createContext, useContext, useState } from 'react';
const b2bLightTheme = createMoovyTheme({
    palette: {
        primaryMain: '#1C273A',
        primaryDark: '#0F1620',
        secondaryMain: '#99BBE0',
        tertiaryMain: '#BDEBF9',
        successMain: '#0BCD61',
        errorMain: '#FF4848',
        warningMain: '#F9CF58',
        infoMain: '#BDEBF9',
        primaryText: '#1C273A',
        secondaryText: '#99BBE0',
        colorMainBackground: '#E9F2F0',
        secondaryBackground: '#FFFFFF',
        surfaceColor: '#FFFFFF',
        colorMenuBackgroundGradient: '#CEFA1F',
        headerPrimaryText: '#1C273A',
        smartGreen: '#CEFA1F',
    },
    style: {
        fontFamily: '"Archivo", sans-serif',
        fontSize: 14,
        menuFontSize: 17,
        menuFontWeight: 500,
        buttonFontWeight: 700,
        tableHeadFontWeight: 700,
        borderRadius: 10,
    },
});
const b2bDarkTheme = createMoovyTheme({
    mode: 'dark',
    palette: {
        primaryMain: '#CEFA1F',
        primaryDark: '#A5C919',
        secondaryMain: '#99BBE0',
        tertiaryMain: '#BDEBF9',
        successMain: '#0BCD61',
        errorMain: '#FF4848',
        warningMain: '#F9CF58',
        infoMain: '#CEFA1F',
        primaryText: '#FFFFFF',
        secondaryText: '#99BBE0',
        colorMainBackground: '#1D2428',
        secondaryBackground: '#14181B',
        surfaceColor: '#14181B',
        colorTableHeader: '#2A3035',
        colorMenuBackgroundGradient: '#CEFA1F',
        headerPrimaryText: '#1C273A',
        smartGreen: '#CEFA1F',
    },
    style: {
        fontFamily: '"Archivo", sans-serif',
        fontSize: 14,
        menuFontSize: 17,
        menuFontWeight: 500,
        buttonFontWeight: 700,
        tableHeadFontWeight: 700,
        borderRadius: 10,
    },
});
const themes = {
    'b2b-light': b2bLightTheme,
    'b2b-dark': b2bDarkTheme,
};
const ThemeContext = createContext(undefined);
export const ThemeProvider = ({ children, }) => {
    const [currentTheme, setCurrentTheme] = useState(() => {
        const saved = localStorage.getItem('moovy-theme');
        return saved && themes[saved] ? saved : 'b2b-light';
    });
    const themeObject = themes[currentTheme];
    const setTheme = (theme) => {
        setCurrentTheme(theme);
        localStorage.setItem('moovy-theme', theme);
    };
    return (_jsx(ThemeContext.Provider, { value: { currentTheme, setTheme, themeObject }, children: children }));
};
export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
